import React from "react";
import { MapContainer, TileLayer, Marker, Polyline } from "react-leaflet";
import { X } from "lucide-react";

const ShipmentMapModal = ({ shipment, isOpen, onClose }) => {
  if (!isOpen || !shipment) return null;

  const { currentLocation, destinationLocation } = shipment;

  const center =
    currentLocation?.coordinates?.length === 2
      ? [currentLocation.coordinates[1], currentLocation.coordinates[0]]
      : [20.5937, 78.9629]; // Default India

  return (
    <div className="fixed inset-0 bg-black bg-opacity-70 z-50 flex items-center justify-center">
      <div className="relative w-[95%] h-[90%] bg-white rounded-lg overflow-hidden">
        <button
          onClick={onClose}
          className="absolute top-3 right-3  bg-gray-800 text-white p-2 rounded-full z-[1000]"
        >
          <X size={18} />
        </button>

        <MapContainer center={center} zoom={6} scrollWheelZoom={true} className="h-full w-full" zoomAnimation={false} fadeAnimation={false} markerZoomAnimation={false}>
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution="© OpenStreetMap contributors"
          />

          {currentLocation?.coordinates?.length === 2 && (
            <Marker
              position={[currentLocation.coordinates[1], currentLocation.coordinates[0]]}
            />
          )}

          {destinationLocation?.coordinates?.length === 2 && (
            <Marker
              position={[destinationLocation.coordinates[1], destinationLocation.coordinates[0]]}
            />
          )}

          {currentLocation?.coordinates?.length === 2 &&
            destinationLocation?.coordinates?.length === 2 && (
              <Polyline
                positions={[
                  [currentLocation.coordinates[1], currentLocation.coordinates[0]],
                  [destinationLocation.coordinates[1], destinationLocation.coordinates[0]],
                ]}
                color="blue"
              />
            )}
        </MapContainer>
      </div>
    </div>
  );
};

export default ShipmentMapModal;
